import React from 'react';
import { DropResult } from 'react-beautiful-dnd';

import {
  CmFormErrorMessage,
  CmLabelAndInput,
  CmLabelAndTextarea,
  CmStack,
} from '@/components/uiParts';
import {
  MenuManagementDragItems,
  MenuManagementSearchAndDragArea,
} from '@/pages/menu-managements/components/SearchAndDrag';
import { MenuManagementCardWrapper } from '@/pages/menu-managements/components/Wrapper';
import { menuForm } from '@/pages/menu-managements/menus/service';
import { MenuFormError } from '@/pages/menu-managements/menus/validate';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';

type Props = {
  titleJa: string;
  memo: string;
  error: MenuFormError;
  searchItems: SearchItem[];
  selectedItems: SearchItem[];
  searchItemName: string;
  brandSelectValue: string;
  isSearching: boolean;
  handleInputTitleJa: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputMemo: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleOnDragEnd: (result: DropResult) => void;
  handleSearchItemNameInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddSelectItems: (item: SearchItem) => void;
  handleDeleteDragItem: (itemId: string) => void;
};

export const MenuManagementMenusForm: React.FC<Props> = ({
  titleJa,
  memo,
  error,
  searchItems,
  selectedItems,
  searchItemName,
  handleInputTitleJa,
  handleInputMemo,
  handleOnDragEnd,
  handleSearchItemNameInput,
  handleAddSelectItems,
  brandSelectValue,
  isSearching,
  handleDeleteDragItem,
}): JSX.Element => {
  return (
    <MenuManagementCardWrapper>
      <CmStack spacing="20px">
        <CmLabelAndInput
          isRequired
          id={menuForm.titleJa.key}
          isInvalid={error.titleJa.isError}
          label={menuForm.titleJa.label}
          fontWeight="bold"
          value={titleJa}
          onChange={handleInputTitleJa}
        >
          <CmFormErrorMessage>{error.titleJa.message}</CmFormErrorMessage>
        </CmLabelAndInput>
        <CmLabelAndTextarea
          id={menuForm.memo.key}
          isInvalid={error.memo.isError}
          label={menuForm.memo.label}
          fontWeight="bold"
          error={<CmFormErrorMessage>{error.memo.message}</CmFormErrorMessage>}
          value={memo}
          onChange={handleInputMemo}
        />
        <MenuManagementSearchAndDragArea
          targetName="カテゴリ"
          {...{
            brandSelectValue,
            searchItems,
            isSearching,
            selectedItems,
            searchItemName,
            handleSearchItemNameInput,
            handleAddSelectItems,
          }}
        >
          <MenuManagementDragItems
            targetOption="categories"
            {...{ selectedItems, handleOnDragEnd, handleDeleteDragItem }}
          />
        </MenuManagementSearchAndDragArea>
      </CmStack>
    </MenuManagementCardWrapper>
  );
};
